import React, { useContext, useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { LocaleContext } from '../../routes'
import Header, { HeaderTitle } from '../../styles/header'
import Score from '../Score'
import Back from './Back'
import Help from './Help'
import { useHistory } from 'react-router-dom'

export default ({ title, score, backgroundColor, hasHelpButton, onBack, isGiftScrolled, isSmall }) => {
  const locale = useContext(LocaleContext)
  const history = useHistory()
  const location = useLocation().pathname.substr(1).toUpperCase()
  const isGiftPage = location.includes('GIFT')
  const headerTitle = title ? title : locale[location]
  const goToHelp = () => history.push('/help')

  const [isScrolled, setScrolled] = useState()

  useEffect(() => {
    const scrollHandler = e => {
      if (e.target.scrollTop === 0)
        setScrolled(false)
      else if (!isScrolled)
        setScrolled(true)
    }

    document.body.addEventListener('scroll', scrollHandler)
    return () => document.body.removeEventListener('scroll', scrollHandler);
  }, [isScrolled])

  useEffect(() => {
    isGiftScrolled !== null && setScrolled(isGiftScrolled)
  }, [isGiftScrolled])

  return (
    <Header
      backgroundColor={backgroundColor}
      className={`${hasHelpButton && "transparent"} ${isScrolled && "stuck"}`}
    >
      <Back onClick={onBack} isBright={hasHelpButton || isGiftPage} />
      {!hasHelpButton &&
        <HeaderTitle
          fontSize={isSmall && '0.9rem'}
          color={isGiftScrolled ? "white" : backgroundColor}
        >
          {headerTitle}
        </HeaderTitle>
      }
      {!!score && <Score status="header">{score}</Score>}
      {!!hasHelpButton && <Help text={locale.HELP} onClick={goToHelp} />}
    </Header>
  )
}
